import { useUserLookupLoadable } from 'modules/user/hooks/useUserLookupLoadable';
import { UserRole } from 'modules/user/models/user';
import { useGuaranteedAuth } from 'shared/hooks/useAuth';

import { LoadingError } from 'shared/components/loading/LoadingError/LoadingError';
import { LoadingSpinner } from 'shared/components/loading/LoadingSpinner/LoadingSpinner';
import { TeacherRegistrationForm } from 'users/pages/UserRegistration/TeacherRegistrationForm/TeacherRegistrationForm';
import { StudentRegistrationForm } from 'users/pages/UserRegistration/StudentRegistrationForm/StudentRegistrationForm';
import { ParentRegistrationForm } from 'users/pages/UserRegistration/ParentRegistrationForm/ParentRegistrationForm';

export const UserRegistration = () => {
    const {tokenData} = useGuaranteedAuth();
    const {user, loading, error} = useUserLookupLoadable(tokenData.id);

    return (
        <>
            {error && <LoadingError/>}
            {loading && <LoadingSpinner/>}
            {user && (
                user.roles.includes(UserRole.Teacher) ? (
                    <TeacherRegistrationForm />
                ) : user.roles.includes(UserRole.Student) ? (
                    <StudentRegistrationForm />
                ) : (
                    <ParentRegistrationForm />
                )
            )}
        </>
    );
};